import { render, staticRenderFns } from "./bindwallet.vue?vue&type=template&id=54b3f402"
import script from "./bindwallet.vue?vue&type=script&lang=js"
export * from "./bindwallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports